import OtpRecordsPage from "../../otps/OtpRecordsPage";

export default function BankOtps() {
  return (
    <OtpRecordsPage
      apiPath="/otps"
      fallbackNote="OTP records for users in your bank / NBFC only."
    />
  );
}
